
import { cn } from "./cn";
import styles from "./Skeleton.module.css";

export type SkeletonProps = {
  width?: string;
  height?: string;
  radius?: string;
  className?: string;
};

export function Skeleton({ width, height, radius, className }: SkeletonProps) {
  return (
    <span
      className={cn(styles.skeleton, className)}
      aria-hidden="true"
      style={{
        width: width ?? "100%",
        height: height ?? "var(--db-space-200)",
        borderRadius: radius,
      }}
    />
  );
}

export type SkeletonLinesProps = {
  lines?: number;
  className?: string;
};

export function SkeletonLines({ lines = 3, className }: SkeletonLinesProps) {
  return (
    <span className={cn(styles.lines, className)} aria-hidden="true">
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} />
      ))}
    </span>
  );
}

export type SkeletonRowsProps = {
  rows?: number;
  avatar?: boolean;
  className?: string;
};

export function SkeletonRows({ rows = 5, avatar = true, className }: SkeletonRowsProps) {
  return (
    <span className={cn(styles.rows, className)} aria-hidden="true">
      {Array.from({ length: rows }, (_, index) => (
        <span key={index} className={styles.row}>
          {avatar ? <Skeleton width="var(--db-space-400)" height="var(--db-space-400)" radius="var(--db-radius-full)" /> : null}
          <span className={styles.rowBody}>
            <Skeleton width="40%" height="var(--db-space-150)" />
            <Skeleton width="65%" height="var(--db-space-150)" />
          </span>
        </span>
      ))}
    </span>
  );
}

export type SkeletonGridProps = {
  items?: number;
  height?: string;
  className?: string;
};

export function SkeletonGrid({ items = 6, height = "var(--db-space-800)", className }: SkeletonGridProps) {
  return (
    <span className={cn(styles.grid, className)} aria-hidden="true">
      {Array.from({ length: items }, (_, index) => (
        <Skeleton key={index} height={height} radius="var(--db-radius-8)" />
      ))}
    </span>
  );
}
